import StatisticsAPI from "./StatisticsAPI";
import store from "../../store/index";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY

const StatisticsMethods = {
  async getStatsInRange(config) {
    const rangeStartMS = new Date(2023, 1, 1).valueOf();
    const rangeEndMS = new Date(2023, 8, 13).valueOf();

    const response = await StatisticsAPI.getStatsInRange(AuthStore.user._id, rangeStartMS, rangeEndMS, config);
    console.log("Stats: ", response);
    return response.data.graphData;
  },
};

export default StatisticsMethods;
